import {Action} from "@ngrx/store";
import {HttpErrorResponse} from "@angular/common/http";
import {ProductsResponse} from "../../models/shop/products-response.model";
import {ProductRequest} from "../../models/shop/product-request.model";

export enum Paragraph73ActionTypes {
    LOAD_PARAGRAPH73 = '[PARAGRAPH73] Load PARAGRAPH73',
    LOAD_PARAGRAPH73_COMPLETE = '[PARAGRAPH73] Load PARAGRAPH73 Complete',
    LOAD_PARAGRAPH73_FAIL = '[PARAGRAPH73] Load PARAGRAPH73 FAIL',
    SEARCH_PARAGRAPH73 = '[PARAGRAPH73] Search',
    UPDATE_SCROLLING_POSITION = '[PARAGRAPH73] Update Scrolling Position',
    GET_BATCH_FROM_CACHE = '[PARAGRAPH73] Push batch in visible list'
}

export class LoadParagraph73Action implements Action {
    readonly type = Paragraph73ActionTypes.LOAD_PARAGRAPH73;

    constructor(public payload: ProductRequest) { // == Query
    }
}

export class LoadParagraph73CompleteAction implements Action {
    readonly type = Paragraph73ActionTypes.LOAD_PARAGRAPH73_COMPLETE;

    constructor(public payload: ProductsResponse) {
    }
}

export class LoadParagraph73FailAction implements Action {
    readonly type = Paragraph73ActionTypes.LOAD_PARAGRAPH73_FAIL;

    constructor(public payload: HttpErrorResponse) {
    }
}

export class SearchShopAction implements Action {
    readonly type = Paragraph73ActionTypes.SEARCH_PARAGRAPH73;

    constructor(public payload: ProductRequest) {};
}

export class UpdateScrollingPositionAction implements Action {
    readonly type = Paragraph73ActionTypes.UPDATE_SCROLLING_POSITION;

    constructor(public payload: number) {};
}

export class GetBatchFromCacheAction implements Action {
    readonly type = Paragraph73ActionTypes.GET_BATCH_FROM_CACHE;

    constructor() {};
}



export type Paragraph73Actions =
    LoadParagraph73Action |
    LoadParagraph73CompleteAction |
    LoadParagraph73FailAction |
    SearchShopAction |
    UpdateScrollingPositionAction |
    GetBatchFromCacheAction;